export const UrlHelper = () => {
  const update = (param: string) => {
    if (typeof window !== 'undefined' && !import.meta.env.SSR) {
      const currentURL = window.location.href;
      const segments = currentURL.split('/');

      if (currentURL.includes(param)) {
        segments.pop();
      }

      const newURL = segments.join('/');
      window.history.pushState({}, '', newURL);
    }
  };

  const getProfileUrl = (shortUrl: string) => {
    return `${import.meta.env.VITE_BASE_URL}/${shortUrl}`;
  };

  return {
    update,
    getProfileUrl,
  };
};
